import Link from "next/link";

export default function Izmjeni({ id, tip = "utisak" }) {
    return (
        <>
            <div className="absolute right-5 bottom-5 border border-gray p-2 px-3 rounded text-xs">
                <Link href={`/ostavi-${tip}?id=${id}`}>
                    <a>izmjeni</a>
                </Link>
            </div>
            <div className="absolute right-24 bottom-5 border border-red p-2 px-3 rounded text-xs text-red">
                <Link href={`/ostavi-${tip}?id=${id}&obrisi=true`}>
                    <a>obriši</a>
                </Link>
            </div>
        </>
    );
}
